import { render, staticRenderFns } from "./AccidentsInfo.vue?vue&type=template&id=4982510c&scoped=true&"
import script from "./AccidentsInfo.vue?vue&type=script&lang=js&"
export * from "./AccidentsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccidentsInfo.vue?vue&type=style&index=0&id=4982510c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982510c",
  null
  
)

export default component.exports